__turbopack_context__.v({
  "cta": "quickAccess-module-scss-module__BByF6G__cta",
  "ctaContainer": "quickAccess-module-scss-module__BByF6G__ctaContainer",
  "logoButtons": "quickAccess-module-scss-module__BByF6G__logoButtons",
  "quickAccessRoot": "quickAccess-module-scss-module__BByF6G__quickAccessRoot",
});
